import * as tslib_1 from "tslib";
import { ElementRef, ViewContainerRef } from '@angular/core';
import { sleep } from '../../../classes/sleep';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var Expand;
var bottomOffsetHeight = 30;
var retrySizeSetupTime = 50;
var retrySizeSetup = 5;
var ExpanderComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExpanderComponent, _super);
    function ExpanderComponent(_vcr) {
        var _this = _super.call(this, _vcr) || this;
        _this.mode = 'auto';
        _this.cascadeClasses = [];
        _this.loadExpander();
        return _this;
    }
    ExpanderComponent.prototype.loadExpander = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.setMapViewRef()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.createExpander()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ExpanderComponent.prototype.setMapViewRef = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.mapViewRef) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.mapViewRef = parent_1.mapView;
                        this.setupClasses();
                        return [3 /*break*/, 4];
                    case 3:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExpanderComponent.prototype.setupClasses = function () {
        var lastChecked = this.hostElement.assignedSlot ? this.hostElement.assignedSlot.parentElement : this.hostElement.parentElement;
        var allUIClasses = this.mapViewRef.container.className.split(' ').filter(function (x) { return x.startsWith('esri-view-'); });
        allUIClasses = allUIClasses.concat(lastChecked.className.split(' ').filter(function (x) { return x.startsWith('esri-ui-'); }));
        var lastClasses = allUIClasses.concat([]);
        while (lastClasses.length) {
            lastChecked = lastChecked.parentElement;
            lastClasses = lastChecked.className.split(' ').filter(function (x) { return x.startsWith('esri-ui-'); });
            allUIClasses = allUIClasses.concat(lastClasses);
        }
        this.cascadeClasses = this.cascadeClasses.concat(allUIClasses);
    };
    ExpanderComponent.prototype.setupSize = function (count) {
        if (count === void 0) { count = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var content;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        content = this.getExpandContent();
                        if (!content) return [3 /*break*/, 1];
                        content.style.maxHeight = this.getCurrentViewHeight();
                        this.mapViewRef.on('resize', function () {
                            _this.getExpandContent().style.maxHeight = _this.getCurrentViewHeight();
                        });
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(count < retrySizeSetup)) return [3 /*break*/, 3];
                        return [4 /*yield*/, sleep(retrySizeSetupTime)];
                    case 2:
                        _a.sent();
                        this.setupSize(count++);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ExpanderComponent.prototype.getExpandContent = function () {
        return this.expanderRef.nativeElement.querySelector('.esri-expand .esri-expand__content');
    };
    ExpanderComponent.prototype.getCurrentViewHeight = function () {
        return (this.mapViewRef.container.offsetHeight - bottomOffsetHeight) + "px";
    };
    ExpanderComponent.prototype.createExpander = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Expand])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Expand = _a[0];
                        this.expand = new Expand({
                            collapseIconClass: this.collapseIconClass,
                            container: this.expanderRef.nativeElement,
                            content: this.expanderContentRef.nativeElement,
                            expanded: this.expanded,
                            expandIconClass: this.expandIconClass,
                            view: this.mapViewRef,
                            autoCollapse: this.autoCollapse,
                            collapseTooltip: this.collapseTooltip,
                            expandTooltip: this.expandTooltip,
                            mode: this.mode,
                            group: this.group,
                            iconNumber: this.iconNumber
                        });
                        return [4 /*yield*/, this.setupSize()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ExpanderComponent.prototype, "expanded", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ExpanderComponent.prototype, "autoCollapse", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], ExpanderComponent.prototype, "iconNumber", void 0);
    return ExpanderComponent;
}(BaseComponent));
export { ExpanderComponent };
